'use strict';

angular.module('atex.dam').controller('DamPrintController', ['$rootScope', '$scope', 'DamListService', 'preloader','$modal', '$q',
                                                     function($rootScope, $scope, DamListService, preloader, $modal, $q) {
  $scope.articles = [];
  $scope.images = [];
  $scope.missing = [];
  $scope.imageLocations = [];
  $scope.counter = 0;
  
  $scope.$on("dam:print",function(event, selected){
    $scope.selection = angular.copy(selected);
      $scope.create().then(function(evt){
      if(evt) {
        print();
      }
      $scope.reset();
    });
  });

  $scope.$on("dam:print-form-loaded", function(event){
    $scope.build();
  });
  
  $scope.$on("dam:print-document", function(event){
    print();
  });
  
  $scope.reset = function() {
    $scope.articles = [];
    $scope.images = [];
    $scope.missing = [];
    $scope.imageLocations = [];
    $scope.counter = 0;
  };
  
  $scope.build = function() {
    return $q(function(resolve, reject) {
      $scope.reset();

      angular.forEach($scope.selection, function (select) {
        var objType = select._data.aspects.contentData.data.inputTemplate;
        if ( ( objType  === 'p.DamArticle' ) || (objType  === 'p.DamWireArticle') || (objType === 'p.NosqlArticle') || (objType === 'p.NosqlArticleCollab') || (objType === 'p.StandardArticle')) {
          $scope.articles.push(select);
        } else if ( (objType === 'p.DamImage') || (objType === 'p.DamWireImage') || (objType === 'p.NosqlImage') || (objType === 'p.NosqlImageCollab') ) {
          $scope.images.push(select);
          $scope.imageLocations.push(select._data.aspects.contentData.data.lowUrl);
        } else if ( (objType === 'p.DamGraphic') || (objType === 'p.DamWireGraphic') ) {
          $scope.images.push(select);
          $scope.imageLocations.push(select._data.aspects.contentData.data.thumbUrl);
        } else {
          $scope.missing.push(select);
        }
      });

      if( $scope.imageLocations.length > 0) { 
        preloader.preloadImages( $scope.imageLocations ).then(
            function handleResolve( imageLocations ) {
              $rootScope.$broadcast('dam:print-document-success');
              resolve(true);
            },
            function handleReject( imageLocation ) {
              $rootScope.$broadcast('dam:print-document-success');
              resolve(true);
            },
            function handleNotify( event ) {
              $scope.percentLoaded = event.percent;
              $rootScope.$broadcast('dam:print-document-percent',event.percent);
              resolve(false);
            }
        );
      } else {
        if($scope.articles.length>0) {
          $scope.counter = $scope.counter + 1;
        }
        
        if($scope.missing.length>0) {
          $scope.counter = $scope.counter + 1;
        }
      }
    });
  };
  
  $scope.create = function() {
    var modaleScope = $rootScope.$new(true);

    var modal = $modal({
      show : true,
      scope : modaleScope,
      template : 'views/dam-print-modal.html',
      modalClass : 'confirm-modal ng-cloak',
      backdrop : 'static',
      keyboard : false
    });

    modaleScope.verified = (modaleScope.confirm !== true);

    var deferred = $q.defer();

    var destroyModal = function() {
      modal.then(function(modalEl) {
        modalEl.on('hidden.bs.modal', function() {
          modaleScope.$destroy();
          angular.element(this).remove();
        });

        modalEl.modal('hide');
      });
    };

    modaleScope.doCancel = function() {
      destroyModal();
      deferred.resolve(false);
    };
    
    modaleScope.cancel = function() {
      destroyModal();
      deferred.resolve(true);
    };

    return deferred.promise;
  };
}]).directive('checkEnd', function() {
  return function(scope, element, attrs) {
    if (scope.$last && scope.imageLocations.length===0) {
      scope.counter = scope.counter - 1;
      
      if(scope.counter === 0) {
        scope.$root.$broadcast('dam:print-document-percent',100);
        scope.$root.$broadcast('dam:print-document-success');
      }
    }
  };
});